module.exports = __webpack_public_path__ + "static/img/zhongye-zhiye.40dbd1e3.png";